import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gs-ga-creation',
  templateUrl: './gs-ga-creation.component.html',
  styleUrls: ['./gs-ga-creation.component.css']
})
export class GsGaCreationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/accountmaster/gs-ga-creation/gs-ga-creation.component.ts